import type { FC } from "react";

import { Row } from "@hightouch/htui";
import { SortVerticalIcon } from "src/ui/icons";

type SortIcon = {
  className?: string;
  sortDirection?: string | null;
  isHovered: boolean;
};

export const SORT_ARROW_OPACITY = {
  asc: [1, 0.5],
  desc: [0.5, 1],
} as const satisfies Record<"asc" | "desc", readonly [number, number]>;

export const SortIcon: FC<SortIcon> = ({
  sortDirection,
  isHovered,
  ...props
}) => {
  const opacity: readonly [number, number] = sortDirection?.startsWith("asc")
    ? SORT_ARROW_OPACITY.asc
    : sortDirection?.startsWith("desc")
      ? SORT_ARROW_OPACITY.desc
      : isHovered
        ? [0.5, 0.5]
        : [0, 0];

  return (
    <Row align="center" ml={1} borderRadius="md" {...props}>
      <SortVerticalIcon
        leftOpacity={opacity[0]}
        rightOpacity={opacity[1]}
        size={16}
      />
    </Row>
  );
};
